<!-- vue -->
<script setup lang="ts">
import AccordionPanel, {
  type AccordionPanelProps
} from "primevue/accordionpanel";

export interface TaiAccordionPanelProps extends AccordionPanelProps {}

defineProps<TaiAccordionPanelProps>();
</script>

<template>
  <AccordionPanel v-bind="{ ...$props, ...$attrs }">
    <slot></slot>
  </AccordionPanel>
</template>
